module.exports = __webpack_public_path__ + "static/media/eWallet_logo.d9fec264.svg";